<ng-container [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzRequired]="isRequired">
      <p class="form-desc">How intense is the behavior when it occurs?</p>
    </nz-form-label>
    <div class="radio-wrapper">
      <nz-radio-group
        id="languageLevel"
        nzName="radiogroup"
        formControlName="behaviourIntensityId">
        <span
          nz-radio
          *ngFor="let intensity of behaviourIntensityList; trackBy: trackById"
          [nzValue]="intensity.id"
          class="box-radio"
          tabindex="0"
          (click)="showWarningModal()"
          (keydown)="handleKeyDown($event)">
          {{ intensity.name }}
          {{ intensity?.description ? '(' + intensity.description + ')' : '' }}
        </span>
      </nz-radio-group>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="form.get('behaviourIntensityId')?.hasError('required')">
        Please select behavior intensity.
      </div>
    </div>
  </nz-form-item>
</ng-container>
